import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getCar, getPhoto, getDiagnosis, getInspect, getCarDueDate, getEstimate, getCarSimple, getCarReregist } from 'app/store/modules/carInfo';

export default function useCarInfo() {
	const { car, carSimple, dueDate, photo, diagnosis, inspect, estimate, reregist } = useSelector((state) => state.carInfo, shallowEqual);
	const dispatch = useDispatch();

	const getPhotoInfo = useCallback((carId, auth) => dispatch(getPhoto(carId, auth)), [dispatch]);
	const getDiagnosisInfo = useCallback((carId, auth) => dispatch(getDiagnosis(carId, auth)), [dispatch]);
	const getInspectInfo = useCallback((carId, auth) => dispatch(getInspect(carId, auth)), [dispatch]);

	const getCarInfo = useCallback((carId, auth) => dispatch(getCar(carId, auth)), [dispatch]);

	const getCarInfoSimple = useCallback((carId) => dispatch(getCarSimple(carId)), [dispatch]);

	const getCarDueDateInfo = useCallback((carId, auth) => dispatch(getCarDueDate(carId, auth)), [dispatch]);

	const getEstimateInfo = useCallback((carId) => dispatch(getEstimate(carId, 0, 0, false)), [dispatch]);
	const getCarReregistInfo = useCallback((carId, auth) => dispatch(getCarReregist(carId, auth)), [dispatch]);

	return {
		car,
		carSimple,
		photo,
		diagnosis,
		inspect,
		estimate,
		reregist,
		getCarInfo,
		getPhotoInfo,
		getDiagnosisInfo,
		getInspectInfo,
		dueDate,
		getCarDueDateInfo,
		getEstimateInfo,
		getCarInfoSimple,
		getCarReregistInfo,
	};
}
